import { WorkerStatus } from "../models/worker";

export interface WorkerStatusColorTokens {
    incomplete: string;
    pending: string;
    candidate: string;
    placed: string;
    rejected: string;
    blocked: string;
}

export const getWorkerStatusColor = (
    status: WorkerStatus,
    tokens: WorkerStatusColorTokens,
    fallback: string,
): string => {
    const colors: Record<WorkerStatus, string> = {
        [WorkerStatus.INCOMPLETE]: tokens.incomplete,
        [WorkerStatus.PENDING_DOCUMENTS]: tokens.pending,
        [WorkerStatus.PENDING_APPROVAL]: tokens.pending,
        [WorkerStatus.PENDING]: tokens.pending,
        [WorkerStatus.CANDIDATE]: tokens.candidate,
        [WorkerStatus.PLACED]: tokens.placed,
        [WorkerStatus.REJECTED]: tokens.rejected,
        [WorkerStatus.BLOCKED]: tokens.blocked,
        [WorkerStatus.RESERVE_POOL]: tokens.pending,
    };

    return colors[status] ?? fallback;
};
